<template>
  <div class="flex flex-col">
    <a v-if="agent.photo" :href="agent.link" class="aspect-square bg-center bg-cover"
      v-lazy:background-image="agent.photo.sizes.medium">
      <div class="h-full w-full border-8 border-white/40 hover:border-accent/50"></div>
    </a>
    <a v-else :href="agent.link" class="aspect-square bg-center bg-cover m-8"
      v-lazy:background-image="agent.photo ? agent.photo.sizes.medium : '/images/user.svg'"></a>

    <div class="py-4 flex-grow">
      <p class="text-white tracking-wide text-[22px] font-medium leading-normal" v-html="agent.title"></p>
      <p class="uppercase text-accent tracking-wider font-medium text-base" v-html="agent.agent_title"></p>
      <a :href="'mailto:' + agent.agent_email" class="flex items-center tracking-wide text-white/70 hover:text-white/100 md:text-sm xl:text-lg lg:text-base py-2">
        <svg-vue icon="email" class="fill-current text-accent h-4 w-4 mr-2" ></svg-vue>
        {{ agent.agent_email }}
      </a>
      <a :href="'tel:' + agent.agent_phone" class="flex items-center text-xl lg:text-lg text-white/70 hover:text-white/10 xl:text-lg 0">
        <svg-vue icon="phone" class="fill-current text-accent h-4 w-4 mr-2" ></svg-vue>
        {{ agent.agent_phone }}
      </a>
    </div>

    <div class="flex w-full space-x-4">
      <a :href="agent.link"
        class="form-button text-base bg-accent hover:bg-primary-dark flex items-center justify-center w-1/2 px-2"><span
          class="hidden sm-inline">Read </span>Bio</a>
      <a :href="agent.link + '#listings'"
        class="form-button text-base bg-primary-dark hover:bg-accent border-2 border-accent flex items-center justify-center w-1/2 px-2"><span
          class="hidden sm-inline">View </span>Listings</a>
    </div>

  </div>
</template>

<script>
export default {
  name: "AgentCard",

  props: {
    agent: {
      type: Object,
      required: true
    }
  }
}
</script>
